import React from "react";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";

/**
 * Debug Input Component for Heading View
 * Input form for heading projection calculations
 */
const Debuginput = (props) => {
  const currentDimension = props.dimensions;

  return (
    <div id="page">
      <Header />
      <Footer />
      <div className="page-content header-clear-medium">
        <div className="card card-style contact-form">
          <div className="content">
            <form action="php/contact.htm" method="post" className="contactForm" id="contactForm">
              <fieldset>
                <div className="row">
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-name">
                      <label className="contactNameField color-theme" htmlFor="contactNameField">
                        Tunnel Direction:
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="direction"
                        name="direction"
                        aria-describedby="basic-addon3"
                        value={currentDimension.direction}
                        onChange={props.updatedimension}
                        readOnly={props.currenttrace > 0}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label className="contactEmailField color-theme" htmlFor="contactEmailField">
                        Dip direction:
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="dir"
                        name="dir"
                        aria-describedby="basic-addon3"
                        value={currentDimension.dir}
                        onChange={props.updatedimension}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label className="contactEmailField color-theme" htmlFor="contactEmailField">
                        Tunnel Radius
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="radiusofcrown"
                        name="radiusofcrown"
                        aria-describedby="basic-addon3"
                        value={currentDimension.radiusofcrown}
                        onChange={props.updatedimension}
                        readOnly={props.currenttrace > 0}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label className="contactHeightField color-theme" htmlFor="contactHeightField">
                        Dip Amount:
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="amt"
                        name="amt"
                        aria-describedby="basic-addon3"
                        value={currentDimension.amt}
                        onChange={props.updatedimension}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label className="contactHeightField color-theme" htmlFor="contactHeightField">
                        Heading RD
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="rd"
                        name="rd"
                        aria-describedby="basic-addon3"
                        value={currentDimension.rd}
                        onChange={props.updatedimension}
                      />
                    </div>
                  </div>
                  <React.Fragment>
                    <div className="col-md-6">
                      <div className="form-field form-email">
                        <label className="contactHeightField color-theme" htmlFor="contactHeightFromField">
                          Position on
                        </label>
                        <div className="input-style">
                          <select
                            id="heightfrom"
                            name="heightfrom"
                            aria-describedby="basic-addon3"
                            value={currentDimension.heightfrom}
                            onChange={props.updatedimension}
                          >
                            <option value="leftspl">Left Crown</option>
                            <option value="rightspl">Right Crown</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-field form-email">
                        <label className="contactHeightField color-theme" htmlFor="contactHeightFromField">
                          Distance from center line
                        </label>
                        <input
                          type="text"
                          className="round-small"
                          id="pointheight"
                          name="pointheight"
                          aria-describedby="basic-addon3"
                          value={currentDimension.pointheight}
                          onChange={props.updatedimension}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                </div>
                <div className="form-button">
                  <button
                    type="button"
                    className="btn bg-green-dark text-uppercase font-900 btn-m btn-full rounded-sm shadow-xl contactSubmitButton"
                    value={props.label}
                    onClick={() => {
                      props.showoutput();
                    }}
                  >
                    {props.label}
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Debuginput;
